import Web3 from 'web3'
import { getProvider } from '~/services/account'
import { EBO_CONTRACT_ADDR, RPC_URL } from '~/utils/constants'

export const ETH_TOKEN = {
  symbol: 'ETH',
  ccsymbol: 'ETH',
  name: 'Ethereum',
  decimals: 18,
  address: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
}

const MIN_ERC20 = [
  {
    constant: true,
    inputs: [
      {
        name: '_owner',
        type: 'address',
      },
    ],
    name: 'balanceOf',
    outputs: [
      {
        name: 'balance',
        type: 'uint256',
      },
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
]

const BALANCE = {
  name: 'balanceOf',
  type: 'function',
  inputs: [
    {
      name: 'account',
      type: 'address',
    },
    {
      name: 'id',
      type: 'uint256',
    },
  ],
}

export const getBalance = async (tokenAddress, walletAddress, decimals = 18) => {

  // Check balance on mainnet for EBO tokens
  const web3 = tokenAddress === EBO_CONTRACT_ADDR
    ? new Web3(new Web3.providers.HttpProvider(RPC_URL))
    : new Web3(getProvider())
  
  if (tokenAddress.toLowerCase() === ETH_TOKEN.address) {
    const balance = await web3.eth.getBalance(walletAddress)
    return parseFloat(web3.utils.fromWei(balance))
  } else {
    try {
      const contract = new web3.eth.Contract(MIN_ERC20, tokenAddress)
      const decoded = await contract.methods.balanceOf(walletAddress).call()
      if (decoded.length < decimals) {
        const numTrailingZeros = decoded
          .split('')
          .reduce((acc, val) => (val === '0' ? acc + 1 : acc), 0)
        const numZerosAfterDecimal = decimals - numTrailingZeros
        return parseFloat(`0.${'0'.repeat(numZerosAfterDecimal)}${decoded}`)
      }

      const wholePart = decoded.slice(0, decoded.length - decimals)
      const fractionalPart = decoded.slice(decoded.length - decimals)
      if (wholePart + fractionalPart !== decoded)
        throw new Error('Problem converting balance to float')
      return parseFloat(`${wholePart}.${fractionalPart}`)
    } catch (e) {
      // Catch errors, usually on dev for tokens that don't exist
      console.warn('error getting balance of', tokenAddress, e)
      return 0
    }
  }
}

export const get1155Balance = async (contractAddress, tokenAddress, walletAddress) => {
  const web3 = new Web3(getProvider())
  const balance = await web3.eth.call(
    {
      to: contractAddress,
      data: web3.eth.abi.encodeFunctionCall(BALANCE, [walletAddress, tokenAddress]),
    },
    (err, balance) => {
      if (err) {
        console.error('Error fetching balance for', tokenAddress, err)
        return 0
      } else {
        return parseInt(web3.eth.abi.decodeParameter('uint256', balance))
      }
    }
  )
  return parseInt(web3.eth.abi.decodeParameter('uint256', balance))
}

// This stopped working for some reason, no time to debug, switch to regular promises, think of batch request again later when more tokens are minted
// export const batch1155Balances = (contractAddress, tokenAddresses, walletAddress) => {
//   if (!contractAddress || !walletAddress) return Promise.resolve([])
//   const web3 = new Web3(getProvider())
//   const batch = new web3.BatchRequest()
//   const balancePromises = tokenAddresses.map((tokenAddress) => {
//     return new Promise((resolve) => {
//       batch.add(
//         web3.eth.call.request(
//           {
//             to: contractAddress,
//             data: web3.eth.abi.encodeFunctionCall(BALANCE, [walletAddress, tokenAddress]),
//           },
//           (err, balance) => {
//             if (err) {
//               console.error('Error fetching balance for', tokenAddress, err)
//               resolve(0)
//             } else {
//               resolve(parseInt(web3.eth.abi.decodeParameter('uint256', balance)))
//             }
//           }
//         )
//       )
//     })
//   })
//   batch.execute()
//   return Promise.all(balancePromises)
// }

export const batch1155Balances = (contractAddress, tokenAddresses, walletAddress) => {
  if (!contractAddress || !walletAddress) return Promise.resolve([])
  const web3 = new Web3(getProvider())
  const balancePromises = tokenAddresses.map((tokenAddress) => {
    return new Promise((resolve) => {
        web3.eth.call(
          {
            to: contractAddress,
            data: web3.eth.abi.encodeFunctionCall(BALANCE, [walletAddress, tokenAddress]),
          },
          (err, balance) => {
            if (err) {
              console.error('Error fetching balance for', tokenAddress, err)
              resolve(0)
            } else {
              resolve(parseInt(web3.eth.abi.decodeParameter('uint256', balance)))
            }
          }
        )
    })
  })
  return Promise.all(balancePromises)
}

export const ensToAddress = (ensName) => {
  const web3 = new Web3(getProvider())
  return web3.eth.ens.getAddress(ensName)
}
